/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/esm/Container';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AnyAction } from 'redux';
import {
  getNextPosts,
  getPosts
} from '../../../redux/slices/analytics/postsList';
import { PostShortAnalytics } from '../../../components/postShortAnalytics';
import IsLoadingIndicator from '../../../components/isLoadingIndicator';
import { Pagination } from '../../../components/pagination';
import { InView } from 'react-intersection-observer';
import { getLocationDetails } from '../../../redux/slices/location/locationDetails';

const PostAnalytics: React.FC = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const dispatch = useDispatch();
  const { locationslug } = useParams();
  useEffect(() => {
    if (locationslug ?? '') {
      dispatch(getLocationDetails(locationslug) as unknown as AnyAction);
    }
  }, [dispatch, locationslug]);
  const getPagePosts = (page: number): void => {
    window.scrollTo(0, 0);
    dispatch(getNextPosts(page) as unknown as AnyAction);
    setPageNumber(pageNumber + 1);
  };

  const { isUpdating, currentPagePosts, isLoading, rowsNumber, count } =
    useSelector((state: any) => state.postsList);
  useEffect(() => {
    dispatch(
      getPosts(locationslug, 'ready', {
        has_been_published_on_platform: 'True',
        ordering: '-latest_upload_to_platform_timestamp',
        analytics: 'True'
      }) as unknown as AnyAction
    );
  }, [dispatch]);
  return (
    <Container>
      <div className="d-flex flex-end">
        {isLoading && !isUpdating ? <IsLoadingIndicator /> : ''}
      </div>

      {currentPagePosts.map((post: any): any => {
        return (
          <InView triggerOnce={true} key={post.uuid}>
            {({ ref, inView }) => (
              <div ref={ref}>
                <PostShortAnalytics post={post} inView={inView} />
                <div className="mb-4" />
              </div>
            )}
          </InView>
        );
      })}
      <Pagination
        total={count}
        pageRows={rowsNumber}
        nextPageCallBack={getPagePosts}
      />
    </Container>
  );
};
export default PostAnalytics;
